/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchTaskStatusEnum } from './BatchTaskStatusEnum';
import {
  BatchTaskStatusEnumFromJSON,
  BatchTaskStatusEnumFromJSONTyped,
  BatchTaskStatusEnumToJSON,
} from './BatchTaskStatusEnum';

/**
 *
 * @export
 * @interface BatchDownloadStatus
 */
export interface BatchDownloadStatus {
  /**
   *
   * @type {BatchTaskStatusEnum}
   * @memberof BatchDownloadStatus
   */
  status: BatchTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof BatchDownloadStatus
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof BatchDownloadStatus
   */
  error?: string | null;
  /**
   *
   * @type {number}
   * @memberof BatchDownloadStatus
   */
  progress?: number | null;
}

/**
 * Check if a given object implements the BatchDownloadStatus interface.
 */
export function instanceOfBatchDownloadStatus(value: object): value is BatchDownloadStatus {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function BatchDownloadStatusFromJSON(json: any): BatchDownloadStatus {
  return BatchDownloadStatusFromJSONTyped(json, false);
}

export function BatchDownloadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchDownloadStatus {
  if (json == null) {
    return json;
  }
  return {
    status: BatchTaskStatusEnumFromJSON(json['status']),
    url: json['url'] == null ? undefined : json['url'],
    error: json['error'] == null ? undefined : json['error'],
    progress: json['progress'] == null ? undefined : json['progress'],
  };
}

export function BatchDownloadStatusToJSON(value?: BatchDownloadStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    status: BatchTaskStatusEnumToJSON(value['status']),
    url: value['url'],
    error: value['error'],
    progress: value['progress'],
  };
}
